import produce from 'immer'

import {
  INSIGHTS_LOAD,
  INSIGHTS_RELOAD,
  INSIGHTS_LOAD_SUCCESS,
  INSIGHTS_RELOAD_SUCCESS,
  INSIGHTS_LOAD_FAILURE,
  InsightsAction
} from './actions'
import { InsightsState } from './types'

const initialState: InsightsState = {
  loading: false,
  error: null,
  items: [],
  count: 0
}

export const reducer = (
  state = initialState,
  action: InsightsAction
): InsightsState => {
  return produce(state, draft => {
    switch (action.type) {
      case INSIGHTS_LOAD: {
        draft.loading = true
        draft.error = null
        break
      }

      case INSIGHTS_RELOAD: {
        // Silent reload - don't set loading to true
        break
      }

      case INSIGHTS_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.items = action.insights
        draft.count = action.insights.length
        break
      }

      case INSIGHTS_RELOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.items = action.insights
        draft.count = action.insights.length
        break
      }

      case INSIGHTS_LOAD_FAILURE: {
        draft.loading = false
        draft.error = action.error
        break
      }

      default:
        break
    }
  })
}
